// Data Source Models
export interface DataSource {
  id: string;
  name: string;
  type: string;
  category: string;
  icon: string;
  description: string;
}

export const dataSources: DataSource[] = [
  {
    id: "snowflake",
    name: "Snowflake",
    type: "snowflake",
    icon: "❄️",
    description: "Cloud data warehouse platform",
    category: "database"
  },
  {
    id: "postgres",
    name: "PostgreSQL",
    type: "postgres",
    icon: "🐘",
    description: "Open source relational database",
    category: "database"
  },
  {
    id: "mysql",
    name: "MySQL",
    type: "mysql",
    icon: "🐬",
    description: "Popular open source database",
    category: "database"
  },
  {
    id: "mongodb",
    name: "MongoDB",
    type: "mongodb",
    icon: "🍃",
    description: "NoSQL document database",
    category: "database"
  },
  {
    id: "s3",
    name: "Amazon S3",
    type: "s3",
    icon: "☁️",
    description: "Cloud object storage service",
    category: "cloud"
  },
  {
    id: "api",
    name: "REST API",
    type: "api",
    icon: "🔌",
    description: "Connect to any REST API endpoint",
    category: "api"
  },
  {
    id: "sharepoint",
    name: "SharePoint",
    type: "sharepoint",
    category: "File Storage",
    icon: "📁",
    description: "Connect to SharePoint document libraries"
  }
];
